import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SitucaoDataValid } from '../models/situacaoDataValid.model';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GetSituacaoDataValidService {

  constructor(private http: HttpClient) { }

  retornaSituacao(cpf: string){
    return this.http.get<SitucaoDataValid>(`${environment.TrustCRMApiHost}api/DataValid/GetSituacaoDataValid?nrCpf=${cpf}`)
  }
}
